import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import ProdutoComponent from './ProdutoComponent';

const Produtos = () => {

  return (
    <Fragment>
      <Breadcrumbs parent="Cadastros" title="Produto" mainTitle="Listagem de Produtos" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <ProdutoComponent />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );

};

export default Produtos;